import { IconChevronDown, IconLogout, IconUser } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";
import MxMenu from "@rf-l1/MxMenu";
import { Box, MenuItem, Typography, Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { MxMenuItemProps } from "@rf-l1/MxMenu";
import { useTheme } from "@mui/material";
import useUserHelp from "@rf-hooks/useUserHelp";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@/shared/hooks/use-media-query";
import MxImageBlur from "@rf-l1/images/MxImageBlur";

interface UserData {
  name: string | null;
  picture: string | null;
  people_id: number | null;
  international_id: string | null;
  user_type_code: {
    name: string;
  };
}

interface DetailAccountProps {
  userData: UserData;
  hasInternationalId: boolean;
}

const DetailAccount = ({ userData, hasInternationalId }: DetailAccountProps) => {
  return (
    <Grid container flexDirection="column">
      <Grid item xs={"auto"}>
        <MxTypography variant="caption" color="grey.800" fontWeight={500} lines={1}>
          {userData?.name}
        </MxTypography>
      </Grid>

      <Grid item xs={"auto"}>
        <MxTypography variant="overline" color="grey.600" fontWeight={400} lines={1}>
          {userData?.user_type_code?.name}
        </MxTypography>
      </Grid>

      {hasInternationalId && (
        <Grid container columnGap={0.5} alignItems="center" item xs={12}>
          <Typography
            variant="overline"
            fontWeight={500}
            color="text.primary"
            lineHeight={0.8}
          >
            Cod. RE
            <Box component="span" sx={{ color: "error.main" }}>
              /
            </Box>
            MAX
          </Typography>

          <MxTypography
            variant="overline"
            color="error.main"
            fontWeight={500}
            lines={1}
            autoCopy
          >
            {userData?.international_id}
          </MxTypography>
        </Grid>
      )}
    </Grid>
  );
};

const AccountSection = () => {
  const { USER, USER_HAS } = useUserHelp();
  const theme = useTheme();
  const { isMobile } = useMediaQuery();
  const navigate = useNavigate();

  const handleSignOut = () => navigate("/logout");
  const handleProfile = () => navigate(`/profile/${USER.userData?.people_id}`);

  const menuItems: MxMenuItemProps[] = [
    {
      label: "Mi perfil",
      template: (
        <MenuItem>
          <DetailAccount
            userData={USER.userData!}
            hasInternationalId={USER_HAS.INTERNATIONAL_ID}
          />
        </MenuItem>
      ),
      onClick: () => {},
      show: isMobile
    },
    { label: "Mi perfil", icon: <IconUser />, onClick: handleProfile },
    { label: "Cerrar sesión", icon: <IconLogout />, onClick: handleSignOut }
  ];

  if (isMobile) {
    return (
      <Grid item width={40}>
        <MxMenu items={menuItems}>
          <MxImageBlur
            src={USER.userData?.picture!}
            width={40}
            height={40}
            objectFit="cover"
            borderRadius={100}
          />
        </MxMenu>
      </Grid>
    );
  }

  return (
    <Grid container wrap="nowrap" alignItems="center" gap={1}>
      <Grid item xs="auto" width={50}>
        <MxImageBlur
          src={USER.userData?.picture!}
          width={40}
          height={40}
          objectFit="cover"
          borderRadius={100}
        />
      </Grid>
      <Grid item xs="auto">
        <DetailAccount
          userData={USER.userData!}
          hasInternationalId={USER_HAS.INTERNATIONAL_ID}
        />
      </Grid>
      <Grid item xs="auto" width={50}>
        <MxMenu items={menuItems}>
          <MxIcons size={20} color="grey.700">
            <IconChevronDown />
          </MxIcons>
        </MxMenu>
      </Grid>
    </Grid>
  );
};

export default AccountSection;
